import React from "react";
import { ContactInfo } from "../contact/ContactInfo";
import { HoursBlock } from "../contact/HoursBlock";
import { QuoteForm } from "../contact/QuoteForm";
import { ServiceArea } from "../ServiceArea";

export default function Contact({ t, lang }) {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-20 md:py-32 bg-brand-primary text-white overflow-hidden"
    >
      <div className="absolute inset-0 grain" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="section-tag !text-brand-accent" data-testid="contact-tag">
              {t.contact.tag}
            </span>
            <h2
              data-testid="contact-title"
              className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter mt-5 leading-[1.05]"
            >
              {t.contact.title}
            </h2>
            <p className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed max-w-md">
              {t.contact.subtitle}
            </p>
            <ContactInfo t={t} />
            <HoursBlock t={t} />
            <div className="mt-3">
              <ServiceArea t={t} theme="dark" testId="contact-service-area" compact />
            </div>
          </div>

          <div className="lg:col-span-7">
            <QuoteForm t={t} lang={lang} />
          </div>
        </div>
      </div>
    </section>
  );
}
